// extracted by mini-css-extract-plugin
export default {"tupacGrid":"pm-z","tupacHeader":"qm-z","tupacHeader2":"rm-z","tupacMenu":"sm-z","tupacMenu2":"tm-z","tupacMain":"um-z","tupacMain2":"vm-z"};